import { Resume } from 'packages/types'
import { createContext, ReactNode, useState } from 'react'
import { useLocalStorage } from 'builder/hooks/useLocalStorage'
import { getEmptyResumeObject } from '../utils/getEmptyResumeData'

type ContextValue = {
  resume: Resume
  showEmailRequiredError: number
  shouldFocusEmailField: number
  setShowEmailRequiredError: (show: number) => void
  setShouldFocusEmailField: (show: number) => void
  updateResumeFields: (update: Partial<Resume>) => void
  toggleEmailRequiredError: () => void
  resetResume: () => void
  setFileForPrefill: (file: File | null) => void
  fileForPrefill: File | null
}

const defaultLsResume: Partial<Resume> = {}
const defaultResume: Resume = getEmptyResumeObject()
const lsKey = 'GUEST_EDITOR_RESUME'

export const GuestResumeContext = createContext<ContextValue>({
  resume: defaultResume,
  updateResumeFields: () => {},
  showEmailRequiredError: 0,
  shouldFocusEmailField: 0,
  setShowEmailRequiredError: () => {},
  setShouldFocusEmailField: () => {},
  toggleEmailRequiredError: () => {},
  resetResume: () => {},
  setFileForPrefill: () => {},
  fileForPrefill: null,
})

interface GuestResumeContextProviderProps {
  children: ReactNode
}

export const GuestResumeContextProvider = (props: GuestResumeContextProviderProps) => {
  const { children } = props
  const [lsResume, setLsResume] = useLocalStorage<Partial<Resume>>(lsKey, defaultLsResume)
  const [showEmailRequiredError, setShowEmailRequiredError] = useState(0)
  const [shouldFocusEmailField, setShouldFocusEmailField] = useState(0)
  const [fileForPrefill, setFileForPrefill] = useState<File | null>(null)

  const updateResumeFields = (update: Partial<Resume>) => {
    setLsResume(value => ({ ...value, ...update }))
  }

  const toggleEmailRequiredError = () => {
    if (!lsResume.email) {
      setShowEmailRequiredError(Math.random() + 1)
    }
    setShouldFocusEmailField(Math.random() + 1)
  }

  const resetResume = (resetParams?: Partial<Resume>) => {
    setLsResume({ ...defaultLsResume, ...resetParams })
  }

  const value = {
    resume: { ...defaultResume, ...lsResume },
    updateResumeFields,
    showEmailRequiredError,
    setShowEmailRequiredError,
    setShouldFocusEmailField,
    toggleEmailRequiredError,
    resetResume,
    shouldFocusEmailField,
    fileForPrefill,
    setFileForPrefill,
  }

  return <GuestResumeContext.Provider value={value}>{children}</GuestResumeContext.Provider>
}
